export default "__VITE_ASSET__116e5ef1__"